import React, { useState, useEffect, useMemo } from "react";
import './recetario.css'

export function RegistrarPP(props) {
  const [fechaActual] = useState(new Date().toISOString().split('T')[0]);
  const [fechaEntrega, setFechaEntrega] = useState(new Date().toISOString().split('T')[0]);
  const [observacion, setObservacion] = useState("");
  const [formData, setFormData] = useState({});
  const [productos, setProductos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);

  const traerProductos = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch('/api/productosProduccion');
      if (!response.ok) {
        throw new Error(`Error fetching productos: ${response.statusText}`);
      }
      const data = await response.json();
      setProductos(data.productos || []);
      setLoading(false);
    } catch (error) {
      setError(error.message);
      setLoading(false);
      console.error(`Error loading productos: ${error.message}`);
    }
  };

  useEffect(() => {
    traerProductos();
  }, []);

  const productosPorCategoria = useMemo(() => {
    return productos.reduce((acc, producto) => {
      const categoria = producto.Categoria || 'OTROS';
      
      if (categoria === 'OTROS') {
        return acc;
      }
      
      if (!acc[categoria]) {
        acc[categoria] = [];
      }
      acc[categoria].push(producto);
      return acc;
    }, {});
  }, [productos]);

  const productosOtros = useMemo(() => {
    return productos.filter(producto => 
      (producto.Categoria || 'OTROS') === 'OTROS'
    );
  }, [productos]);

  const totalesCategoria = useMemo(() => {
    const totales = {};
    
    Object.keys(productosPorCategoria).forEach(categoria => {
      totales[categoria] = productosPorCategoria[categoria].reduce((total, producto) => {
        const cantidad = parseFloat(formData[`producto_${producto.IdProductoProduccion}`]) || 0;
        return total + cantidad;
      }, 0);
    });
    
    return totales;
  }, [formData, productosPorCategoria]);

  const totalOtros = useMemo(() => {
    return productosOtros.reduce((total, producto) => {
      const cantidad = parseFloat(formData[`producto_${producto.IdProductoProduccion}`]) || 0;
      return total + cantidad;
    }, 0);
  }, [formData, productosOtros]);

  const obtenerProductosConCantidad = () => {
    const todosProductos = [...Object.values(productosPorCategoria).flat(), ...productosOtros];
    return todosProductos.filter(producto => {
      const cantidad = parseFloat(formData[`producto_${producto.IdProductoProduccion}`]) || 0;
      return cantidad > 0;
    });
  };

  const handleChangeIndividual = (e, productoId, categoria = null) => {
    const { value } = e.target;
    const numValue = parseFloat(value) || 0;

    setFormData(prev => ({
      ...prev,
      [`producto_${productoId}`]: numValue
    }));
  };

  const handleObservacionesChange = (e, grupoKey) => {
    const { value } = e.target;
    setFormData(prev => ({
      ...prev,
      [`observaciones_${grupoKey}`]: value
    }));
  };

  const limpiarFormulario = () => {
    setFormData({});
    setObservacion("");
    setFechaEntrega(new Date().toISOString().split('T')[0]);
  };

  const cerrarModal = () => {
    if (props.onClose) {
      props.onClose();
    }
  };

  const guardarPedido = async () => {
    const productosConCantidad = obtenerProductosConCantidad();
    
    if (productosConCantidad.length === 0) {
      alert("Debe ingresar al menos un producto con cantidad mayor a 0");
      return;
    }


    setSaving(true);

    try {
      const pedidoPayload = {
        FechaEmision: fechaActual,
        FechaEntrega: fechaEntrega,
        Observacion: observacion
      };

      const responsePedido = await fetch('/api/pedidosProduccion', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(pedidoPayload)
      });

      if (!responsePedido.ok) {
        throw new Error('Error al crear el pedido');
      }
 
      const resultadoPedido = await responsePedido.json();
      const idPedidoProduccion = resultadoPedido.pedidoId;

      const detallesPayload = productosConCantidad.map(producto => ({
        IdPedidoProduccion: idPedidoProduccion,
        IdProductoProduccion: producto.IdProductoProduccion,
        Cantidad: parseFloat(formData[`producto_${producto.IdProductoProduccion}`]) || 0,
        Observacion: observacion
      }));

      const responseDetalles = await fetch('/api/pedidosProduccion/detalleProduccion', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(detallesPayload)
      });

      if (!responseDetalles.ok) {
        throw new Error('Error al guardar los detalles del pedido');
      }

      alert('Pedido guardado exitosamente');
      
      limpiarFormulario();
      
      if (props.onPedidoGuardado) {
        props.onPedidoGuardado(idPedidoProduccion);
      }

      cerrarModal();

    } catch (error) {
      console.error('Error al guardar el pedido:', error);
      alert('Error al guardar el pedido: ' + error.message);
      
      limpiarFormulario();
      cerrarModal();
      
    } finally {
      setSaving(false);
    }
  };

  const cancelarPedido = () => {
    if (window.confirm("¿Está seguro de cancelar el pedido? Se perderán todos los datos ingresados.")) {
      limpiarFormulario();
      
      if (props.onCancel) {
        props.onCancel();
      }
      
      cerrarModal();
    }
  };

  if (error) {
    return <div className="error">Error: {error}</div>;
  }

  return (
    <div className="order-form-container">

      
      <div className="bakery-order-form">
        <div className="abed_content-fecha">
          <label>Registro:</label> 
          <input type="date" className="abed__input-fecha" value={fechaActual} readOnly />
          
          <label className="ml-3">Entrega:</label>
          <input 
            type="date" 
            className="abed__input-fecha-entrega"
            style={{ backgroundColor: '#fffff' }} 
            value={fechaEntrega}
            onChange={(e) => setFechaEntrega(e.target.value)}
            min={fechaActual}
          />
        </div>

        {Object.entries(productosPorCategoria).map(([categoria, productosCategoria]) => (
          <div key={categoria} className="order-section grupo-section">
            <div className="grupo-container">
              <div className="grupo-principal">
                <div className="input-group principal-input">
                  <label>TOTAL {categoria}</label>
                  <input 
                    type="number" 
                    name={`total_${categoria}`}
                    value={totalesCategoria[categoria] || 0}
                    className="abed__input-numero"
                    placeholder="Total"
                    readOnly
                  />
                </div>
              </div>

              <div className="grupo-variantes">
                {productosCategoria.map((producto) => (
                  <div key={producto.IdProductoProduccion} className="abed__input-group variante-item">
                    <input
                      type="number"
                      name={`producto_${producto.IdProductoProduccion}`}
                      value={formData[`producto_${producto.IdProductoProduccion}`] || ''}
                      onChange={(e) => handleChangeIndividual(e, producto.IdProductoProduccion, categoria)}
                      className="abed__input-numero"
                      placeholder="0"
                      min="0"
                      step="0.001"
                    />
                    <label className="abed__label-numero">
                      {producto.Nombre}
                      {/* <span className="unidad-label">({producto.Unidad})</span> */}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}

        <div className="order-section grupo-section">
          <div className="grupo-container">
            <div className="grupo-principal">
              <div className="input-group principal-input">
                <label>TOTAL OTROS</label>
                <input 
                  type="number" 
                  name="total_otros"
                  value={totalOtros}
                  className="abed__input-numero"
                  placeholder="Total"
                  readOnly
                />
              </div>
            </div>

            <div className="grupo-variantes">
              {productosOtros.map((producto) => (
                <div key={producto.IdProductoProduccion} className="abed__input-group variante-item">
                  <input
                    type="number"
                    name={`producto_${producto.IdProductoProduccion}`}
                    value={formData[`producto_${producto.IdProductoProduccion}`] || ''}
                    onChange={(e) => handleChangeIndividual(e, producto.IdProductoProduccion)}
                    className="abed__input-numero"
                    placeholder="0"
                    min="0"
                    step="0.001"
                  />
                  <label className="abed__label-numero">
                    {producto.Nombre}
                    {/* <span className="unidad-label">({producto.Unidad})</span> */}
                  </label>
                </div>
              ))}
              
              {productosOtros.length === 0 && !loading && (
                <div className="no-productos variante-item">No hay productos en esta categoría</div>
              )}
            </div>
          </div>
        </div>
        <div className="order-section">
          <div className="form-group">
            <label>Observación:</label>
            <textarea
              className="form-control"
              rows="3"
              value={observacion}
              onChange={(e) => setObservacion(e.target.value)}
              placeholder="Ingrese observaciones del pedido..."
            />
          </div>
        </div>
        <div>
          <div className="form-actions">
            <button 
              type="button" 
              className="btn-verde-mfp"
              onClick={guardarPedido}
              disabled={saving}
            >
              {saving ? 'Guardando...' : 'Emitir Pedido'}
            </button>
            <button 
              type="button" 
              className="btn-anular ml-1"
              onClick={cancelarPedido}
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RegistrarPP;